import { useEffect, useState } from "react"
import Wallet from "../../wallet/wallet";
import WalletFlow from "../../walletFlow/walletFlow";
import { TUnauthorizedStoreContainer } from "./TUnauthorizedStoreContainer";

import StoreCategories from "../../store/storeCategories/storeCategories";
import UnauthorizedAppbar from "../../../components/appBar/unauthorizedAppbar";
import SellerInfo from "../../store/sellerInfo";
import { IUnauthorizedContainer } from "./IUnauthorizedContainer";
import Sellers from "../../store/storeCategories/sellers";
import StoreBranches from "../../store/storeBranches";
import CreateNewRequest from "../../createNewRequest/createNewRequest";
import OngoingDetailPurchase from "../../purchase/ongoingDetailPurchase";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";


export default function UnauthorizedContainer() {

    const navigate = useNavigate();
    const setState = (state: string) => navigate(`/public/store/${state === 'storeCategories' ? '' : state}`);
    return (
        <div>
            <UnauthorizedAppbar />
            <Routes>
                <Route index element={<StoreCategories />} />
                <Route path="sellers" element={<Sellers setState={setState} />} />
                <Route path="sellerInfo" element={<SellerInfo setState={setState} />} />
                <Route path="storeBranches" element={<StoreBranches />} />
                <Route path="landingPage" element={<CreateNewRequest />} />
                <Route path="ongoingDetailPurchase/:key?" element={<OngoingDetailPurchase ongoingPurchases={0} setState={setState} setWaitingSales={()=>{}}/>} />
                <Route path="*" element={<Navigate to="/public/store" replace />} />
            </Routes>
        </div>
    )
}
